import TileboxInput from "./tilebox_input_controller"

export default class extends TileboxInput {
  pillLabel() {
    return `Vocals: ${this.label()}`
  }
}

